/**
 * LoadErrorAlert
 *
 * An inline "we couldn't load this" alert with a Retry button, shared by the Billing page's plan
 * block (plans, what's included).
 */

import { Button } from '../ui/button'

interface LoadErrorAlertProps {
  message: string
  onRetry: () => void
  retrying: boolean
  testId: string
  retryTestId: string
}

export function LoadErrorAlert({
  message,
  onRetry,
  retrying,
  testId,
  retryTestId,
}: LoadErrorAlertProps) {
  return (
    <div
      role="alert"
      className="flex items-center justify-between gap-3 rounded-lg border border-destructive/30 bg-destructive/5 p-3 text-sm"
      data-testid={testId}
    >
      <span className="text-destructive">{message}</span>
      <Button
        type="button"
        variant="outline"
        className="min-h-[44px]"
        disabled={retrying}
        data-testid={retryTestId}
        onClick={onRetry}
      >
        Retry
      </Button>
    </div>
  )
}
